import useBundleDetail from './useBundleDetail';
import useBundleEnrollment from './useBundleEnrollment';

import { BundleEnrollmentStatus } from '@redux/bundle/type/BundleDetailType';

const useBundleBannerFooter = () => {
  const { name, price, bundleDetailData, bannerPrimaryColor, bannerSecondaryColor } = useBundleDetail();
  const { bundleEnrollmentStatus } = useBundleEnrollment();

  const isEnrolled = [BundleEnrollmentStatus.ENROLLED, BundleEnrollmentStatus.ENROLLED_EVERY_COURSE].includes(
    bundleEnrollmentStatus,
  );

  return {
    isEnrolled,
    bundleEnrollmentStatus,
    bundleDetailData,
    name,
    price,
    bannerPrimaryColor,
    bannerSecondaryColor,
  };
};

export default useBundleBannerFooter;
